import { EventEmitter, Injectable, Output, Directive } from "@angular/core";
import {Registration} from "../../models/registration";
import {RegistrationServiceLocation} from "../../models/registration-service-location";
import {ServiceLocation} from "../../models/service-location";

@Directive()
@Injectable()
export class LocationService {

  public serviceId: string;
  public registration: Registration;
  public registrationServiceLocationList: RegistrationServiceLocation[];
  public registrationServiceLocation: RegistrationServiceLocation;
  public serviceLocations: ServiceLocation[];
  public serviceLocation: ServiceLocation;
  public showDeterminantBuilder: boolean;
  public addNew: boolean;

  @Output() public editData: EventEmitter<any> = new EventEmitter();
  @Output() public change: EventEmitter<any> = new EventEmitter();
  @Output() public update: EventEmitter<any> = new EventEmitter();

  public initData() {
    this.change.emit({
      serviceId: this.serviceId,
      registration: this.registration,
      registrationServiceLocationList: this.registrationServiceLocationList,
      serviceLocations: this.serviceLocations,
      showDeterminantBuilder: this.showDeterminantBuilder,
      registrationServiceLocation: this.registrationServiceLocation,
    });
  }

  public initEdit() {
    this.editData.emit({
      serviceId: this.serviceId,
      registration: this.registration,
      serviceLocation: this.serviceLocation,
      registrationServiceLocation: this.registrationServiceLocation,
      addNew: this.addNew,
      showDeterminantBuilder: this.showDeterminantBuilder,
    });
  }

  public updateData() {
    this.update.emit({
      update: true,
    });
  }

}
